import { StepBase } from './StepBase'
import { PageStepType } from './PageTypes';

export class StepSection extends StepBase
{
    // Options from the GroupEnd statement
    options_end?    : PageStepType;

    // Track the state of the object
    group_state     : StepSection.SectionState = StepSection.SectionState.Start;

    // The caller can use this for any type of storage while the group is processing.
    user_data?      : any;
}

export namespace StepSection
{
    export enum SectionState {
        Start = 1,
        End
    }
}